import { render, staticRenderFns } from "./index.vue?vue&type=template&id=79be66e5&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=79be66e5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79be66e5",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {MainButton: require('/app/components/main/buttons/MainButton.vue').default})
